var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 49,
    r: 49,
    fill: "#30D14D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.17 32.634a2.244 2.244 0 0 0-3.123-.003l-19.578 18.98-8.472-8.363a2.244 2.244 0 0 0-3.124-.002l-5.225 5.068a2.125 2.125 0 0 0-.002 3.053l15.178 15c.861.843 2.26.844 3.123.002l26.405-25.574c.863-.842.864-2.21.002-3.053l-5.184-5.108z",
    stroke: "#30D14D",
    strokeWidth: 3,
    fill: "#FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox);
export default __webpack_public_path__ + "static/media/checkbox.bee9d9a7.svg";
export { ForwardRef as ReactComponent };